export default __webpack_public_path__ + "static/space1-2f6b20cb8260f27c95a20a8aaca08662.png";